import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/pt-br';
import GenericForm from "Admin/components/GenericForm";
import { GenGet, GenPost } from "state/api";
import LoadingState from "Admin/components/LoadingState";
import MsgAlert from "Admin/components/MsgAlert";

moment.locale('pt-BR');

function EditarAgendamento({ event }) {
  const [clienteLoockup, setClienteLookup] = useState([]);
  const [profissionalLoockup, setProfissionalLookup] = useState([]);
  const [servicosLoockup, setServicosLookup] = useState([]);
  const [finalizarForm , setFinalizarForm] = useState(false);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(true);


  const handleFieldChange = (e) => {
    setFinalizarForm({
      ...finalizarForm,
      [e.target.name]: e.target.value
    });
  };

  const handleLookup = async (endpoint, setter) => {
    try {
      const response = await GenGet(endpoint);
      setter(response);
    } catch (err) {
      setMsg("Erro ao buscar Lookups");
      setTimeout(() => setMsg(null), 3000);
    }
  };

  useEffect(() => {
    Promise.all([
      handleLookup('/clientes/lookup', setClienteLookup),
      handleLookup('/profissionais/lookup', setProfissionalLookup),
      handleLookup('/servicos/lookup', setServicosLookup)
    ]).then(() => setLoading(false));
  }, []);

  const handleUpdate = async (formData) => {
    try {
      const response = await GenPost(`/updateagendamento/${event.id}`, formData);
      setMsg(response.message);
      setTimeout(() => setMsg(null), 3000);
    } catch (err) {
      setMsg(err.message);
      setTimeout(() => setMsg(null), 3000);
    }
  };

  const handleFinalize = async () => {
    try {
      const response = await GenPost(`/finalizaragendamento/${event.id}`, finalizarForm);
      setMsg(response.message);
      setTimeout(() => setMsg(null), 3000);
    
    } catch (err) {
      setMsg(err.message);
      setTimeout(() => setMsg(null), 3000);
    }
  };

  if (loading) {
    return <LoadingState />;
  }

  return (
    <div>
      <GenericForm
        title="Editar Agendamento"
        description="Atualize as informações do agendamento"
        endpoint={`/updateagendamento`}
        fetchEndPoint={`/agendamento`}
        pointer={event.id}
        updateMode={true}
        className='h-full'
        fields={[
          { name: "profissional_id", label: "Profissional", type: "custom-select", options: profissionalLoockup, required: true },
          { name: "cliente_id", label: "Cliente", type: "custom-select", options: clienteLoockup, required: false, search: true },
          { name: "servico_produto_id", label: "Serviço", type: "custom-select", options: servicosLoockup, required: true },
          { name: "duracao", label: "Duração (minutos)", type: "number", default: 15 },
          { name: "recorrencia", label: "Recorrência", type: "select", options: [
              { value: "unica", label: "Única" },
              { value: "diaria", label: "Diária" },
              { value: "semanal", label: "Semanal" },
              { value: "quinzenal", label: "Quinzenal" },
              { value: "mensal", label: "Mensal" },
              { value: "trimestral", label: "Trimestral" },
              { value: "semestral", label: "Semestral" },
              { value: "anual", label: "Anual" },
            ], default: "unica" },
          { name: "data_hora", label: "Data e Hora", type: "datetime-local", required: true },
          { name: "observacoes", label: "Observações", type: "textarea" },
        ]}
        onSubmit={handleUpdate}
      />
      <div className="flex justify-between space-x-4 mt-4">

        <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
            <label className="font-semibold">
                Modo de pagamento
                <span className="text-red-500"> *</span>
            </label>
            <select
                name={'modo_pagamento'}
                value={finalizarForm.modo_pagamento || ""}
                onChange={handleFieldChange}
                className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                >
                
                <option key={1} value={'dinheiro'}>
                    Dinheiro
                </option>
                <option key={2} value={'pix'}>
                    Pix
                </option>
                <option key={3} value={'cartão'}>
                    Cartão
                </option>
            </select>
        </div>
        
        <button
          onClick={handleFinalize}
          className="bg-green-600 text-white h-[30px] py-1 px-4 rounded-sm hover:bg-green-700 transition"
        >
          Finalizar
        </button>
      </div>
      <MsgAlert alert={msg} />
    </div>
  );
}

export default EditarAgendamento;